<template>
  <div class="harvested">
    <OrderListCommon :status="status" @listt="listt" :urlT="urlT"></OrderListCommon>
  </div>
</template> 

<script>
import OrderListCommon from "../common/OrderListCommon";
export default {
  created() {
    this.$emit("Active", 1);  
  },
  data() {
    return {
      status: 20,
      sendList: [],
      urlT:'/Particular/particularHarvested'
    };
  },
  methods: {
    listt(listt) {
      this.sendList = listt;
      this.$emit("list", this.sendList);
    }
  },
  components: {
    OrderListCommon
  }
};
</script>

<style scoped>
.harvested {
  background: rgba(242, 242, 242, 1);
}
</style>